import { getTagSettings, deleteMultipleTagSettings, createOrUpdateTagSetting, getCategorisedTags, updateAppliedTagMap, deleteTagsFromEntity, getCompetencySkillTypes, getCompetencySkillsBasedOnTypes } from '../api'

export const loadTagSettings = ({ state, commit }, institutionId) => {
  return getTagSettings(institutionId)
}

export const deleteTagSettings = ({ state, commit }, uuids) => {
  return deleteMultipleTagSettings(uuids)
}

export const saveTagSetting = ({ state, commit }, data) => {
  return createOrUpdateTagSetting(data)
}

export const loadCategorisedTags = ({ state, commit }, {uuid, entityType}) => {
  return getCategorisedTags(uuid, entityType)
}

export const saveAppliedTagMap = ({ state, commit }, data) => {
  return updateAppliedTagMap(data)
}

export const loadDeleteTagsFromEntity = ({ state, commit }, {url, categoryToBeDeleted}) => {
  return deleteTagsFromEntity(url, categoryToBeDeleted)
}

export const loadSkillTypes = ({ state, commit }, source) => {
  return getCompetencySkillTypes(source)
}

export const loadCompetencySkillsBasedOnTypes = ({ state, commit }, {types, keyword, page}) => {
  return getCompetencySkillsBasedOnTypes(types, keyword, page)
}



// WEBPACK FOOTER //
// ./src/app/tagging/vuex/actions.js